<template>
  <div class="content">
    <div class="profile">
      <div class="titleBox">
        <div class="line"></div>
        <h1 class="title">公司简介</h1>
      </div>
      <p class="text">
        杭州弘维科技有限公司（简称：弘维科技 WIN.TECH）提供电子产品的贴片插件焊接、组装测试与整机外观、结构、模具设计一站式的服务。贴片CHIP贴片精度可达01005，BGA贴片精度PITCH可达0.4mm、双轨上下十温区的回流焊、双轨在线AOI解析精度可达15U。拥有成熟的电子产品组装线以及产品的在线检测能力，技术骨干拥有15年以上的贴片工艺，电子组装测试的行业经验。具有丰富的供应链资源整合能力。
      </p>
    </div>
    <div class="contact">
      <div class="titleBox">
        <div class="line"></div>
        <h1 class="title">联系我们</h1>
      </div>
      <div class="textBox">
        <p class="text">公司名称：杭州弘维科技有限公司</p>
        <p class="text">联系电话：17794584123</p>
        <p class="text">联系地址：杭州市余杭区仁和街道粮站路11号仁和智造1幢3楼</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.content {
  padding: 50rem 25vw;

  .profile {
    width: 50vw;
    height: 300rem;
    background: #ebebeb;
    padding: 30rem 0;

    .titleBox {
      display: flex;
      align-items: center;

      .line {
        width: 8rem;
        height: 50rem;
        background: #83c5ff;
      }

      .title {
        font-size: 30rem;
        margin-left: 30rem;
      }
    }
    .text {
      font-size: 22rem;
      margin-left: 30rem;
      margin-right: 30rem;
    }
  }

  .contact {
    width: 50vw;
    height: 300rem;
    background: #ebebeb;
    padding: 30rem 0;
    margin-top: 100rem;

    .titleBox {
      display: flex;
      align-items: center;

      .line {
        width: 8rem;
        height: 50rem;
        background: #83c5ff;
      }

      .title {
        font-size: 30rem;
        margin-left: 30rem;
      }
    }
    .textBox {
      display: flex;
      flex-direction: column;
      align-items: center;

      .text {
        font-size: 22rem;
        margin-top: 10rem;
      }
    }
  }
}
</style>